import api from './api'
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarListaFichaTecnicaProdutoAcabado = async () => {
  let url = `/producao/ficha-tecnica/produto-acabado`;
  const {data, status} = await api.get(url,  {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}

export const salvarFichaTecnicaProdutoAcabado = async (params) => {
  let url = `/producao/ficha-tecnica/produto-acabado`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.CREATED) {
    logout();
  }

  localStorage.token = data.token;
}

export const excluirFichaTecnicaProdutoAcabado = async (params) => {
  let url = `/producao/ficha-tecnica/produto-acabado`;
  const {data, status} = await api.delete(url, {params,  headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
}

// class fichaTecnicaProducaoAPI {
//   async getProdutosSemFichaTecnicaProducao(headers, params){
//     return await api.get('/get_produtos_sem_ficha_tecnica_producao', {params, headers});
//   }
//
//   async getProdutosMateriaPrima(headers, params){
//     return await api.get('/get_produtos_materia_prima', {params, headers});
//   }
//
//   async setProdutoMateriaPrima(headers, params) {
//     return await api({
//       method: 'post',
//       url: '/set_produto_materia_prima',
//       headers,
//       data: params
//     });
//   }
//
//   async detProdutoMateriaPrima(headers, params) {
//     return await api({
//       method: 'delete',
//       url: '/det_produto_materia_prima',
//       headers,
//       data: params
//     });
//   }
// }
//
// export default new fichaTecnicaProducaoAPI();
